import { useEffect, useState } from "react";
import ServiceCard from "../../components/ServiceCard";
import CustomerService from "../../services/CustomerService";
import Lodder from "../../components/Lodder";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};
const Dashboard = () => {
  const [services, setServices] = useState([]);
  const [showlodder, setShowlodder] = useState(false);
  const [model, setModal] = useState(false);

  useEffect(() => {
    setShowlodder(true);
    CustomerService.GetCustomerServiceList()
      .then((response) => {
        if (response.status) {
          setServices(response.resultData);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setShowlodder(false);
      });
    document.title = "Foundry Law - Dashboard";
    if (localStorage.getItem("pop")) {
      setModal(true);
      localStorage.removeItem("pop");
    }
  }, []);

  const handleModelClose = () => {
    setModal(false);
  };
  return (
    <>
      <Lodder show={showlodder} />
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid mt-5 pt-3">
            <div className="row mx-lg-3 mx-0">
              <div className="col-sm-6">
                <h1 className="m-0">DASHBOARD</h1>
              </div>
              {/* /.col */}
              {/* <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#" className="logout-font">
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item active">Dashboard </li>
                </ol>
              </div> */}
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content mt-3">
          <div className="container-fluid">
            <div className="row  mx-lg-3 mx-0">
              {services.map((item, index) => {
                return <ServiceCard key={index} services={item} />;
              })}
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>

      <Modal
        className="welcome-modal border-none"
        style={{ border: "none" }}
        open={model}
        onClose={handleModelClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <figure className="text-center">
              <img
                src="/FoundryLawLogo.png"
                className="img-fluid logo-dark"
                alt="congrats"
              ></img>
            </figure>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div className="text-center mt-3">
              <span
                style={{
                  fontSize: "22px",
                  fontWeight: 400,
                  lineHeight: 1.5,
                  color: "#212529",
                }}
              >
               <b>
                Welcome <br/>to <br/>Foundry Legal Tools!
                </b> 
              </span>
            </div>
            <div className="text-center mb-4 mt-2">
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.5,
                  color: "#212529",
                }}
              >
                You can start the application for your <br/> Single-Member LLC when
                you are ready.
              </span>
            </div>
          </Typography>
          <div className="text-center mt-2">
            <Button className="btn-submit-secondary" onClick={handleModelClose}>
              OK
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
export default Dashboard;
